import React from 'react';
import { Table } from 'antd';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import { dateFormater, percentChangeCalc } from '../utils';
import Icon from '../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

class TestsDailyTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    var covidData = ReducedData.covidData;
    let dataFiltered = [...covidData].filter(
      (item) => item[dict.totalTestsCompletedinthelastday],
    );
    let tableData = dataFiltered
      .map((item, z) => {
        var yesterdayDaily = dataFiltered[z - 1]
          ? dataFiltered[z - 1][dict.totalTestsCompletedinthelastday]
          : 0;
        var todayDaily = dataFiltered[z - 1]
          ? item[dict.totalTestsCompletedinthelastday]
          : 0;
        return {
          index: z,
          date: dateFormater(item[dict.reportedDate]),
          testsDoneYday:
            dataFiltered[z - 1] && todayDaily.toLocaleString(),
          precentChange: percentChangeCalc(
            todayDaily,
            yesterdayDaily,
            2,
          ),
          percentConfirmedPositive: item[dict.percentPositive] + ' %',
        };
      })
      .reverse();
    tableData.pop();

    const columns = [
      {
        title: trans.date[this.props.lang],
        dataIndex: 'date',
        key: 'date',
        width: '25%',
      },
      {
        title: trans.testing.testsDoneYesterday[this.props.lang],
        dataIndex: 'testsDoneYday',
        key: 'testsDoneYday',
        width: '20%',
      },
      {
        title: trans.general.precentChange[this.props.lang],
        dataIndex: 'precentChange',
        key: 'precentChange',
        width: '25%',
        render: (text, record) => {
          if (Number(text) > 0) {
            return (
              <span>
                <img
                  alt={trans.general.increase[this.props.lang]}
                  style={{ transform: 'rotate(180deg)' }}
                  src={Icon}
                />
                {text} %
              </span>
            );
          } else if (Number(text) < 0) {
            return (
              <span>
                <img
                  alt={trans.general.decrease[this.props.lang]}
                  src={Icon}
                />
                {Math.abs(Number(text))} %
              </span>
            );
          } else {
            return <span> ― </span>;
          }
        },
      },
    ];
    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default TestsDailyTable;
